import {
    Box,
    BoxProps,
    Button,
    ButtonProps,
    Grid,
    GridProps,
    useTheme
} from "@mui/material";
import TextField from "components/formsUI/TextField";
import React from "react";
import { useTranslation } from "react-i18next";

import * as Styles from "pages/requests/stepsIndividual/step2/step2.styles";
import { useTenantContext } from "contexts/tenantContext";

interface Props {
    title: string;
    onBackClick: () => void;
}

// function infoMessageBoxProps(t: any): InfoMessageProps {
//   return {
//     title: t("requestIndividual.step2.warningTitle"),
//     text: t("requestIndividual.step2.warning"),
//     icon: TipsAndUpdatesIcon,
//     isCollapsable: true,
//     isCollapsed: true,
//   };
// }

const Content = (props: Props) => {
    const { title, onBackClick } = props;
    const { currentTenant } = useTenantContext();
    const theme = useTheme();
    const { t: _t } = useTranslation();

    const lowerCase = (input: string): string => {
        return input.charAt(0).toLowerCase() + input.slice(1);
    }

    const t = (key: string): string => {
        return _t(`${key}`, {
            replace: {
                'zoneName': currentTenant ? lowerCase(currentTenant.displayName) : "de politie"
            }
        })
    };

    // TODO : Add to global styles

    const gridContainerProps: GridProps = {
        container: true,
        spacing: 2,
        minHeight: { sm: 400, md: 450 },
    };
    const gridItemFullProps: GridProps = {
        item: true,
        xs: 12,
    };
    const gridItemHalfProps: GridProps = {
        item: true,
        xs: 6,
    };

    const titleProps: BoxProps = {
        component: "h1",
        sx: Styles.titleCSS(theme),
    };

    const buttonProps = (buttonName: string): ButtonProps => {
        if (buttonName === "previous") {
            return {
                onClick: onBackClick,
                variant: "contained",
                sx: Styles.buttonCSS(theme, buttonName),
            };
        } else {
            return {
                type: "submit",
                variant: "contained",
                sx: Styles.buttonCSS(theme, buttonName),
            };
        }
    };

    return (
        <Box sx={Styles.containerCSS(theme)}>
            <Grid {...gridContainerProps}>
                <Grid {...gridItemFullProps}>
                    <Box {...titleProps}>{title}</Box>
                    {/* <InfoMessageBox {...infoMessageBoxProps(t)} /> */}
                    <Box sx={{ textAlign: 'justify', my: '10px' }}>{t("requestIndividual.step2.warning")}</Box>
                </Grid>
                <Grid {...gridItemFullProps}>
                    <TextField
                        name="companyName"
                        label={t("requestIndividual.step2.organizationName")}
                    />
                </Grid>
                <Grid {...gridItemHalfProps}>
                    <TextField
                        name="companyResponsibleFirstName"
                        label={t("requestIndividual.step2.responsibleFirstName")}
                    />
                </Grid>
                <Grid {...gridItemHalfProps}>
                    <TextField
                        name="companyResponsibleLastName"
                        label={t("requestIndividual.step2.responsibleLastName")}
                    />
                </Grid>
                <Grid {...gridItemFullProps}>
                    <TextField
                        name="companyResponsibleEmail"
                        label={t("requestIndividual.step2.responsibleEmail")}
                    />
                </Grid>
            </Grid>

            <Box sx={Styles.buttonContainerCSS(theme)}>
                <Button {...buttonProps("previous")}>{t("buttons.previous")}</Button>
                <Button {...buttonProps("next")}>{t("buttons.next")}</Button>
            </Box>
        </Box>
    );
};
export default Content;
